<template>

	
	<!-- page content -->
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12 col-md-12 col-sm-12 mx-auto user-panel mb-5">

                <div class="row page-header">
                    <div class="col">
                        <h3>Completed Sales</h3>
                    </div>
                </div>
				
                <div class="row">
                    <div class="col">
                        <table class="table mt-2">
                            <thead>
                                <tr>
                                    <th class="w-20">Sale Details</th>
                                    <th>Method</th>
                                    <th>Video</th>
                                    <th>Purchased At</th>
                                    <th>Sale / Chaser</th>
                                    <!-- <th></th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="sale in sales">
                                    <td class="text-center">
                                        <strong>{{ sale.network.name }}</strong> <br/>
                                        <small>({{ sale.purchaser.name }})</small> <br />
                                        <i class="fa fa-exchange"></i> <br/>
                                        {{ sale.owner.name }} <br />
                                    </td>
                                    <td><span class="badge" v-bind:class="{ 'badge-primary': sale.method == 'cdn', 'badge-success': sale.method == 'email', 'badge-dark': sale.method == 'manual' }">{{ sale.method | displayMethod }}</span></td>
                                    <td>{{ sale.video.title }}</td>
                                    <td>{{ sale.created_at | displayDateTime }}</td>
                                    <td>${{ sale.price }} / <span v-if="sale.stringer_cut !== null">${{ sale.stringer_cut }}</span><span v-if="sale.stringer_cut == null">N/A</span></td>
                                    <!-- <td><button class="btn btn-primary btn-block btn-sm">View</button></td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

			</div>
		</div>
	</div>

			
</template>

<script>

    import { EventBus } from '@/utils/events';
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';

	export default {
		name: 'HelloWorld',
		data () {
			return {
				sales: {},
			}
        },
        mounted() {
            this.getCompleteSales();
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getCompleteSales() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/sales?status=complete", this.getAuthorizationHeader()).then((response) => {
                    _this.sales = response.data.data
                });
            }
        },
        filters: {
            displayMethod: function(data) {
                if(data == 'email') {
                    return "Email"
                } else if(data == 'cdn') {
                    return "CDN"
                } else if(data == 'manual') {
                    return "Manual"
                }
            },
            displayDateTime: function(data) {
                return moment.utc(data).local().format('MM/DD/YY h:mm a');
            }
        }
	}
</script>

<style scoped>

</style>
